import React, { useCallback, useMemo } from "react";
import "./DiscoveryBrandList.scss";
import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { NavigateFunction } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import DeletePopup from "../PopupTemplate/PopupTemplate";
import {
  deleteBrandRequest,
  restoreBrandRequest,
  softDeleteBrandRequest,
} from "../../../API/endpoints/Discovery";

export interface Item {
  id: string;
  brand_id: string | undefined;
  brandName: string;
  country: string | undefined;
  postedDate: string;
  match_completion_date: string;
  suitable_partners_count: number;
  no_of_req: number;
  confirmedPartners: number;
  status: string;
  serviceRequirements: any[];
  country_id: number | undefined;
  engagement_model_id: number | undefined;
}
export interface DiscoveryBrandListProps {
  setFlag: any;
  data?: Item[];
  height?: string;
  usertype: string | undefined;
  navigate: NavigateFunction;
  permissions: any;
}

const DiscoveryBrandList: React.FunctionComponent<DiscoveryBrandListProps> = (
  props
) => {
  const { data, usertype, navigate, permissions, setFlag } = props;

  const [deleteID, setDeleteID] = React.useState<any>();
  const [deletePopup, setDeletePopup] = React.useState(false);

  const [popupType, setPopupType] = React.useState<string>("");
  const [popupHeader, setPopupHeader] = React.useState<string>("");
  const [popupBody, setPopupBody] = React.useState<string>("");

  const onHandleViewItem = useCallback(
    (id: string, brandName: string, brandID: string) => {
      switch (usertype) {
        case "brand":
          navigate(
            `/discoverymanagement-brands/${id}&&${brandName}&&${brandID}`
          );
          break;

        case "admin":
          navigate(
            `/discoverymanagement-admin/${id}&&${brandName}&&${brandID}`
          );
          break;

        case "partner":
          navigate(
            `/discoverymanagement-partners/${id}&&${brandName}&&${brandID}`
          );
          break;

        default:
          break;
      }
    },
    [usertype, navigate, permissions]
  );

  const handleCloseDeletePopup = () => {
    setDeletePopup(false);
    setDeleteID("");
  };

  const onDeleteItem = (id: any) => {
    setDeletePopup(false);
    setDeleteID("");
    softDeleteBrandRequest(id)
      .then(async (res) => {
        setDeletePopup(false);
        setDeleteID("");
        // const activity = await CreateActivity(
        //   `Request: ${partnerName} deleted temporarily.`
        // );
        setFlag((flag: any)=>!flag);
      })
      .catch((err) => {
        console.log(err);
        setDeletePopup(false);
        setDeleteID("");
      });
  };

  const onPermanentDeleteItem = (id: any) => {
    setDeletePopup(false);
    setDeleteID("");
    deleteBrandRequest(id)
      .then(async (res) => {
        setDeletePopup(false);
        setDeleteID("");
        // const activity = await CreateActivity(
        //   `Request: ${partnerName} deleted permanently.`
        // );
        setFlag((flag: any)=>!flag);
      })
      .catch((err) => {
        console.log(err);

        setDeletePopup(false);
        setDeleteID("");
      });
  };

  const onRestoreItem = async (id: any) => {
    setDeletePopup(false);
    setDeleteID("");
    restoreBrandRequest(id)
      .then(async (res) => {
        setDeletePopup(false);
        setDeleteID("");
        // const activity = await CreateActivity(
        //   `Request: ${partnerName} restored.`
        // );
        setFlag((flag: any)=>!flag);
      })
      .catch((err) => {
        console.log(err);
        setDeletePopup(false);
        setDeleteID("");
      });
  };

  const getServiceRequirementsForTooltip = (services: any[]) => {
    return services.map((service) => <li>{service?.name}</li>);
  };

  const getServiceRequirements = (services: any[]) => {
    return services.map((service) => getServiceItem(service?.service_id));
  };

  const getServiceItem = (id: number) => {
    switch (id) {
      case 1:
        return (
          <img
            src="../svgs/regulatory.svg"
            alt="regulatory"
            className="serviceIcon"
          />
        );
      case 2:
        return (
          <img
            src="../svgs/importation.svg"
            alt="importation"
            className="serviceIcon"
          />
        );
      case 3:
        return (
          <img
            src="../svgs/warehouse.svg"
            alt="warehouse"
            className="serviceIcon"
          />
        );
      case 4:
        return (
          <img
            src="../svgs/ecomm-management.svg"
            alt="ecomm-management"
            className="serviceIcon"
          />
        );
      case 5:
        return (
          <img
            src="../svgs/retail-distribution.svg"
            alt="retail-distribution"
            className="serviceIcon"
          />
        );
      case 6:
        return (
          <img
            src="../svgs/order-fulfillment.svg"
            alt="order-fulfillment"
            className="serviceIcon"
          />
        );
      case 7:
        return (
          <img
            src="../svgs/marketing.svg"
            alt="marketing"
            className="serviceIcon"
          />
        );
      default:
        return <></>;
    }
  };

  const getProductCategories = (categories: any[]) => {
    return categories.map((cat) => (
      <div className="categoryItem">
        <img
          src="../svgs/storefront.svg"
          alt="storefront"
          className="itemPropertyIcon"
        />
        <p className="itemProperty">{cat?.name}</p>
      </div>
    ));
  };

  const getStatusTextStyle = useCallback((status: string) => {
    switch (status) {
      case "Open":
        return {
          background: "#D1E9FF",
          color: "#1570EF",
        };
      case "Matching Interests":
        return {
          background: "#FEF0C7",
          color: "#DC6803",
        };
      default:
        return {};
    }
  }, []);

  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }: any) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#F9FAFB",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#F9FAFB",
      color: "#000",
    },
  }));

  const DiscoveryBrandListItem: React.FunctionComponent<any> = (props) => {
    const { item } = props;

    const handleDelete = (id: any) => {
      setPopupType("delete");
      setPopupHeader("Confirm Request Deletion");
      setPopupBody("Are you sure you want to delete this request ?");
      setDeleteID(id);
      setDeletePopup(true);
    };
    const handleDeletePermanently = (id: any) => {
      setPopupType("delete-permanently");
      setPopupHeader("Confirm Permanent Request Deletion");
      setPopupBody("Are you sure you want to delete this request permanently?");
      setDeleteID(id);
      setDeletePopup(true);
    };

    const handleRestore = (id: any) => {
      setPopupType("restore");
      setPopupHeader("Confirm Restore");
      setPopupBody("Are you sure you want to restore this request");
      setDeleteID(id);
      setDeletePopup(true);
    };

    return (
      <div className="listItemContainer">
        <div
          className="listItemSection"
          onClick={() =>
            onHandleViewItem(item.id, item.brandName, item.brand_id)
          }
          style={{ opacity: item?.isDeleted ? "0.5" : "1" }}
        >
          <div className="titleContainer">
            <p className="titleText">{item.brandName}</p>
            <p className="statusText" style={getStatusTextStyle(item.status)}>
              {item.status}
            </p>
          </div>
          <div className="detailsItem">
            <img
              src="../svgs/storefront.svg"
              alt="storefront"
              className="itemPropertyIcon"
            />
            <p className="itemProperty">{item.country}</p>
          </div>
          <div className="detailsItem">
            <img
              src="../svgs/event.svg"
              alt="event"
              className="itemPropertyIcon"
            />
            <p className="itemProperty">{item.postedDate}</p>
          </div>
        </div>
        <div
          className="listItemSection"
          onClick={() =>
            onHandleViewItem(item.id, item.brandName, item.brand_id)
          }
          style={{ opacity: item?.isDeleted ? "0.5" : "1" }}
        >
          <p className="titleText">Service requirement</p>

          <BootstrapTooltip
            title={
              <>
                <b>Service Capability</b>
                <ul style={{paddingLeft: "16px"}}>
                  {getServiceRequirementsForTooltip(item?.serviceRequirements)}
                </ul>
              </>
            }
          >
            <div className="serviceItems">
              {getServiceRequirements(item?.serviceRequirements)}
            </div>
          </BootstrapTooltip>
        </div>
        <div
          className="listItemSection categoriesSection"
          onClick={() =>
            onHandleViewItem(item.id, item.brandName, item.brand_id)
          }
          style={{ opacity: item?.isDeleted ? "0.5" : "1" }}
        >
          <p className="titleText">Product Category</p>
          <div className="categoriesContainer">
            {getProductCategories(item?.categories)}
          </div>
        </div>
        <div
          className="listItemSection"
          onClick={() =>
            onHandleViewItem(item.id, item.brandName, item.brand_id)
          }
          style={{ opacity: item?.isDeleted ? "0.5" : "1" }}
        >
          <BootstrapTooltip
            title={
              <>
                <p>Suitable Partners: {item.suitable_partners_count}</p>
                <p>Interested Partners: {item.no_of_req}</p>
                <p>Confirmed Partners: {item.confirmedPartners}</p>
              </>
            }
          >
            <table className="countsContainer">
              <tbody>
                <tr>
                  <th>SP</th>
                  <th>IP</th>
                  <th>CP</th>
                </tr>
                <tr>
                  <td>{item.suitable_partners_count}</td>
                  <td>{item.no_of_req}</td>
                  <td>{item.confirmedPartners}</td>
                </tr>
              </tbody>
            </table>
          </BootstrapTooltip>
        </div>
        {permissions[0]?.sub_modules[0]?.permissions_actions[0]?.permission[0]
          ?.permission && (
          <div className="settingsButton">
            <Dropdown className="account-dropdown">
              <Dropdown.Toggle id="dropdown-basic">
                <IconButton id="settings-button" aria-label="settings">
                  <img
                    src="../svgs/settings.svg"
                    alt="settings"
                    className="itemPropertyIcon"
                  />
                </IconButton>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {item?.isDeleted ? (
                  <Dropdown.Item
                    className="font12-regular"
                    eventKey="2"
                    onClick={() => handleRestore(item.id)}
                  >
                    Restore
                  </Dropdown.Item>
                ) : (
                  <Dropdown.Item
                    className="font12-regular error-600 logout"
                    eventKey="2"
                    onClick={() => handleDelete(item.id)}
                  >
                    Delete
                  </Dropdown.Item>
                )}

                <Dropdown.Item
                  className="font12-regular error-600 logout"
                  eventKey="2"
                  onClick={() => handleDeletePermanently(item.id)}
                >
                  Delete Permanently
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
      </div>
    );
  };

  const list = useMemo(() => {
    return (
      data &&
      data.length > 0 &&
      data.map((item) => {
        return <DiscoveryBrandListItem item={item} />;
      })
    );
  }, [data]);

  return (
    <div
      className="listContainer"
      style={{ height: props.height ? props.height : "79vh" }}
    >
      {list}
      <DeletePopup
        popupHeader={popupHeader}
        popupBody={popupBody}
        isModalOpen={deletePopup}
        onCancel={handleCloseDeletePopup}
        id={deleteID}
        handleFunction={
          popupType === "restore"
            ? onRestoreItem
            : popupType === "delete"
            ? onDeleteItem
            : onPermanentDeleteItem
        }
        isRestore={popupType === "restore" ? true : false}
      />
    </div>
  );
};

export default DiscoveryBrandList;
